export default __webpack_public_path__ + "static/media/latest-news-img14.c114d5b2.jpg";